import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateTeamMeetingConfigQuery } from './useTeamMeetingConfigQuery';
import { invalidateTeamMeetingConfigsQuery } from './useTeamMeetingConfigsQuery';

export interface ITeamMeetingConfigUpdateMutationOptions {
	onSuccess?: (data: Api.ITeamMeetingConfig) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

export function useTeamMeetingConfigUpdateMutation(options: ITeamMeetingConfigUpdateMutationOptions = {}) {
	const { onSuccess, onError } = options;
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ id, request }: { id: string; request: Api.ITeamMeetingConfigUpdateRequest }) => {
			return userSession.webServiceHelper.callAsync<Api.ITeamMeetingConfig>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `TeamMeetingConfig/${id}`,
				}),
				'PUT',
				request
			);
		},
		onSuccess: data => {
			invalidateTeamMeetingConfigsQuery();
			invalidateTeamMeetingConfigQuery(data.id);
			onSuccess?.(data);
		},
		onError,
	});
}
